"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZOOM_ADDRESS_VALID = exports.ZOOM_INITIAL = exports.ADDRESS_TYPES = exports.LOCATION_TYPES = exports.TEXTS = exports.GMAP_PARAMS = void 0;
var GMAP_PARAMS = {
  latitude: 'latitude',
  longitude: 'longitude',
  formattedAddress: 'formatted_address'
};
exports.GMAP_PARAMS = GMAP_PARAMS;
var TEXTS = {
  retrievingLocation: 'Estamos recuperando tu ubicación...',
  retrieveLocationError: 'No pudimos determinar tu ubicación.',
  invalidConfig: 'No se encuentran configuradas en el field las keys a utilizar para alguno de los siguientes campos: latitude, longitude y/o formatted_address',
  placeholder: 'Ingresá una dirección'
};
exports.TEXTS = TEXTS;
var LOCATION_TYPES = {
  rooftop: 'ROOFTOP',
  rangeInterpolated: 'RANGE_INTERPOLATED',
  geometricCenter: 'GEOMETRIC_CENTER'
};
exports.LOCATION_TYPES = LOCATION_TYPES;
var ADDRESS_TYPES = {
  street: 'street_address',
  route: 'route'
};
exports.ADDRESS_TYPES = ADDRESS_TYPES;
var ZOOM_INITIAL = 10;
exports.ZOOM_INITIAL = ZOOM_INITIAL;
var ZOOM_ADDRESS_VALID = 15;
exports.ZOOM_ADDRESS_VALID = ZOOM_ADDRESS_VALID;